module.exports = __webpack_public_path__ + "static/media/jordan_resized.a044a52d.png";